import { render } from "./BookBookingPaymentSelection.vue?vue&type=template&id=52fee20b"
import script from "./BookBookingPaymentSelection.vue?vue&type=script&lang=js"
export * from "./BookBookingPaymentSelection.vue?vue&type=script&lang=js"
script.render = render

export default script